import ApplicationController from './application'

export default class extends ApplicationController {
  submitForm() {
    this.element.requestSubmit()
  }
}
